<template>
  <div class="mx-2">
    <v-list v-if="table_artworks.length > 0" two-line class="mx-0 px-0 mb-2">

      <template v-for="(item, index) in table_artworks">
        <!-- {{item.accession_number}} <b>{{ item.title }}</b> -->

        <!-- <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader> -->
        <!-- <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider> -->
        <v-list-tile :key="item.id">{{item.key}}
          <!-- <v-list-tile-avatar> -->
          <!-- <v-list-tile-action style="width:150px; text-align:center;" class="my-0 mx-0 px-0 text-xs-center align-center justify-center"> -->
            <!-- <img v-if="item.top_photo_id>0"
              v-bind:src="'http://tb-cms.org/data/artwork/' + item.id + '/' + item.top_photo_id + '_th.jpg'" 
            /> -->
          <!-- </v-list-tile-action> -->
          <!-- </v-list-tile-avatar> -->
          <v-list-tile-avatar v-if="c_user.delete_rights">
              <!-- <td> -->
            <v-tooltip right>
              <template #activator="data">
                <span v-on="data.on">
                  <v-btn style="width:20px; height:20px" round color="red" icon small dense @click="remove_from_exhibition(item.id)" hint="Remove Artwork from Exhibition"> 
                    <v-icon small dense color=white>remove</v-icon>
                  </v-btn>                    
                </span>
              </template>
              Remove Artwork from Exhibition
            </v-tooltip>                
                <!-- <v-icon class="ml-2" small>edit</v-icon> -->
              <!-- </td> -->
          </v-list-tile-avatar>
          <v-list-tile-content class="ml-2 pl-0">
            <v-list-tile-sub-title class="subheading">
              <router-link :to="{ name: 'EditArtwork', params: {id: item.id, artwork: item}, path: `/artworks/edit/${item.id}`}">
                {{item.accession_number}} <b>{{ item.title }}</b>, {{ item.production_date_new }}, {{ (item.artist ? item.artist.name : item.name) }}
                <!-- <v-icon class="ml-2" small>edit</v-icon> -->
              </router-link> 
              <!-- <router-link :to="{ name: 'ViewArtwork', params: {id: item.id, artwork: item}, path: `/artworks/view/${item.id}`}" >
                {{ item.title }}
              </router-link> -->
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              {{get_location_name(item.artwork_location_id)}}
              <!-- {{item.artwork_location.name}} -->
              <!-- <span class="text-truncate">{{item.credit}}</span> -->
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

      </template>

    </v-list>

    <template v-else>
      <p class="my-0 mx-0 px-0 text-xs-left align-left justify-left">No Artworks</p>
    </template>

  </div>
</template>

<script>
  export default {
    props:['artist','artworks','text_id'],
    computed: {
      table_artworks () {
        var out = [];
        if (this.artworks.length && this.artworks.length > 0) {
          // console.log('this.artworks')
          // console.log(this.artworks)
          // console.log(this.artworks.map(am => am.id))
          // console.log(this.$store.state.artworks.filter(a => (this.artworks.map(am => am.id)).includes(a.id)))
          var filtered = this.$store.state.artworks.filter(a => (this.artworks.map(am => am.id)).includes(a.id))
          // console.log('filtered')
          // console.log(filtered)
          // filtered.forEach(te => {
          //   te = Object.assign({}, te);
          //   let aids = te.artworks.map(tea => tea.id);
          //   let sas = Object.assign([], this.$store.state.artworks);
          //   // console.log('aidss')
          //   // console.log(aids)
          //   let as = Object.assign(
          //     [],
          //     sas.filter(a => aids.includes(a.id))
          //   );
          //   // let artistsids = te.artists.map(tea => tea.id);
          //   // let sars = Object.assign([], this.$store.state.artists)
          //   // // console.log('aidss')
          //   // // console.log(aids)
          //   // let ars = Object.assign(
          //   //   [],
          //   //   sars.filter(a => artistsids.includes(a.id))
          //   // );
          //   // console.log('as')
          //   // console.log(as)
          //   te.artwork_text = as
          //     .map(
          //       aa =>
          //         `${aa.accession_number} ${aa.title} ${aa.name} ${aa.artist_name}`
          //     )
          //     .toString();
          //   // console.log('te.artwork_text')
          //   // console.log(te.artwork_text)
          //   out.push(te);
          // });
        } 
        return filtered;
      }
    },
    methods: {
      remove_from_exhibition (artwork_id) {
        // console.log(list_id)
        // console.log(artwork_id)
        var exhibition = Object.assign({},this.$store.state.exhibitions.find(e => e.id == this.text_id))
        // console.log(list)
        exhibition.artworks = exhibition.artworks.filter(a => a != artwork_id)
        // let url = `${this.$globals.apiserver}/lists.json`
        // axios.post(url).then((response) => {
        //   this.loading = false;
          // this.resultsArtists = response.data
        this.$store.dispatch('removeArtworkFromExhibition', {e: this.text_id, a: artwork_id})
          // this.displayedData = response.data

        // }).catch((error) => { console.log(error) })
        // console.log(exhibition)
      },        
      artist_artworks (artist_id) {
        var a = Object.assign([],this.$store.state.artworks)
        // console.log('artist_id')
        // console.log(artist_id)
        // console.log(a.artist_id == artist_id)
        var aa = a.filter(a => {
          // console.log('a.artist_id')
          // console.log(a.artist_id)
          // console.log(artist_id)
          return a.artist_id === artist_id}
        )
        // console.log(aa)
        return aa
      },
      clear_selection () {
        this.$store.dispatch('clearCurrentSelection')
        this.selected = []
      },
      select_all () {
      },
      save_currently_selected(a,b) {
        // console.log('///////////')
        // console.log('a = ' + a)
        // console.log('b = ' + b.id)
        setTimeout(function () {
          var temp_selection = Object.assign([], this.$store.state.currentSelection)
          //// console.log(temp_selection)
          if (!a) {
            // console.log('a true')
            if (!temp_selection.includes(b)) {
              // console.log('doesnt include')
              temp_selection.push(b)
            }
          } else {
            // console.log('false')
            var index = temp_selection.indexOf(b);
            // console.log('index = ' + index)
            temp_selection.splice(index,1)
          }
          // this.$store.state.currentSelection
          // console.log(temp_selection)
          // this.selected.forEach(s => {
          //   if (!temp_selection.includes(s)) {
          //     temp_selection.push(s)
          //   }
          // })
          // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
          this.$store.dispatch('saveCurrentSelection',temp_selection)
        }.bind(this),1000)
      },
      save_currently_selected_all(a) {
        // console.log('///////////')
        // console.log('a = ' + a)
        var temp_selection = Object.assign([], this.$store.state.currentSelection)
        // console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b)
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index,1)
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection',temp_selection)
      },
      save_currently_selected_tags() {
        this.$store.dispatch('saveCurrentSelectionTags',this.selected_tags)
        this.ta = this.tagged_artworks
      }      
    }
  }
</script>

<style scoped>
  a {text-decoration: none}
  a:hover {text-decoration: underline}
</style>


// WEBPACK FOOTER //
// src/components/texts/ListRelated.vue